import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import { required } from '@/lib/rule';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordRecoveryForm',
  props: {
    email: null
  },
  emits: ["update:isValidForm", "update:email"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValidForm', data: boolean): void;
  (e: 'update:email', data: string): void;
}), expose: any, slots: any, attrs: any }) {



const isValidForm = ref<boolean>(false);



const updateIsValidForm = (e: boolean) => {
  emits('update:isValidForm', e);
};

const updateEmail = (e: string) => {
  emits('update:email', e);
};

return { __sfc: true,isValidForm, emits, updateIsValidForm, updateEmail, required, sharedMessages }
}

})